import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    allWorkRate: [],
    workRateTotal: null,
    tableLoading: false,
    pageWorkRate: 1,
    perPageWorkRate: 5,
    searchQuery: "",
    pageRules: 1,
    perPageRules: 5,
    allRules: [],
    rulesTotal: null,
    allApprover: [],
    approverTotal: null,
    pageApprover: 1,
    perPageApprover: 5,
    overtimes: [],
    totalOvertimes: null,
    pageOvertimes: 1,
    perPageOvertimes: 5,
    overtimeDate: ["2019/01/19", "2019/12/29"],
    overtimeSearch: "",
    overtimeFilter: "",
  },
  actions,
  mutations,
};
